import React from 'react';

const PrivacyPolicy = () => (
  <div className="max-w-4xl mx-auto px-4 py-10">
    <h1 className="text-3xl font-bold text-green-700 mb-4">Privacy Policy</h1>
    <p className="mb-4 text-gray-700">
      JanShakti respects your privacy. We do not sell or misuse your data. Issue submissions can be anonymous, and your personal identity will not be linked unless explicitly stated.
    </p>
    <p className="mb-4 text-gray-700">
      Your submitted issues are used for democratic accountability and awareness. We may share anonymized data with policymakers or media to highlight public concerns.
    </p>
  </div>
);

export default PrivacyPolicy;
